import { NgModule } from '@angular/core';
import { ExpirationDatePipe } from '@fleet-beat/libs-core/src/lib/pipes/expiration-date.pipe';
import { AddressPipe } from './address.pipe';
import { AreaToSquareKmPipe } from './area.pipe';
import { CombinedLoadingPipe } from './combined-loading.pipe';
import { DocumentStatusPipe } from './document-status.pipe';
import { DvirStatusPipe } from './dvir-status.pipe';
import { EnumToTextPipe } from './enum-to-text.pipe';
import { FindTemplatePipe } from './find-template.pipe';
import { FormDebugPipe } from './form-debug.pipe';
import { FormatFileFromFileTypePipe } from './format-file-from-file-type.pipe';
import { FormatFileFromUrlPipe } from './format-file-from-url.pipe';
import { TimeFromNowPipe } from './fromNow.pipe';
import { GetIdPipe } from './get-id.pipe';
import { LogRecordIconPipe } from './log-record-icon.pipe';
import { LogBookViolationPipe } from './logbook-violation.pipe';
import { MsToTimePipe } from './ms-to-time.pipe';
import { RouteEventPipe } from './route-event.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { SecondsToTimePipe } from './seconds-to-time.pipe';
import { TextToClassPipe } from './text-to-class.pipe';
import { TranslatePipe } from './translate.pipe';
import { UsaPhoneNoPipe } from './usa-phone-no.pipe';
import { UserRolePipe } from './user-role.pipe';
import { VehicleOwnershipPipe } from './vehicle-ownership.pipe';
import { ViolationTypePipe } from './violation-type.pipe';
import { WarningTypeComparePipe } from './warning-type-compare.pipe';
import { MalfunctionLabelPipe } from './malfunction-label.pipe';
import { UserRoleAdaptedPipe } from './user-role-adapted.pipe';
import { LogbookDatePipe } from '@fleet-beat/libs-core/src/lib/pipes/logbook-date.pipe';
import { ShortTzDisplayPipe } from './short-tz-display.pipe';
import { TimezonedDatePipe } from './timezoned-date.pipe';
import { HasAnyWarningOfTypePipe } from '@fleet-beat/libs-core/src/lib/pipes/has-warning-of-type.pipe';
import { WarningsLabelPipe } from '@fleet-beat/libs-core/src/lib/pipes/warnings-label.pipe';
import { ViolationWarningTooltipPipe } from './violation-warning-tooltip.pipe';
import { CompanyAddressPipe } from './company-address.pipe';
import { GeofenceTypePipe } from './geofence-type.pipe';
import { LatestParamsSyncPipe } from './last-params-sync.pipe';

@NgModule({
  declarations: [
    UsaPhoneNoPipe,
    TextToClassPipe,
    EnumToTextPipe,
    FormDebugPipe,
    SafeUrlPipe,
    FindTemplatePipe,
    CombinedLoadingPipe,
    GetIdPipe,
    AddressPipe,
    UserRolePipe,
    VehicleOwnershipPipe,
    RouteEventPipe,
    DocumentStatusPipe,
    FormatFileFromUrlPipe,
    FormatFileFromFileTypePipe,
    TranslatePipe,
    MsToTimePipe,
    AreaToSquareKmPipe,
    LogBookViolationPipe,
    DvirStatusPipe,
    TimeFromNowPipe,
    SecondsToTimePipe,
    LogRecordIconPipe,
    ExpirationDatePipe,
    ViolationTypePipe,
    WarningTypeComparePipe,
    WarningsLabelPipe,
    HasAnyWarningOfTypePipe,
    MalfunctionLabelPipe,
    UserRoleAdaptedPipe,
    LogbookDatePipe,
    ShortTzDisplayPipe,
    TimezonedDatePipe,
    ViolationWarningTooltipPipe,
    CompanyAddressPipe,
    GeofenceTypePipe,
    LatestParamsSyncPipe,
  ],
  exports: [
    UsaPhoneNoPipe,
    TextToClassPipe,
    EnumToTextPipe,
    FormDebugPipe,
    SafeUrlPipe,
    FindTemplatePipe,
    CombinedLoadingPipe,
    GetIdPipe,
    AddressPipe,
    UserRolePipe,
    VehicleOwnershipPipe,
    RouteEventPipe,
    DocumentStatusPipe,
    FormatFileFromUrlPipe,
    FormatFileFromFileTypePipe,
    TranslatePipe,
    MsToTimePipe,
    AreaToSquareKmPipe,
    LogBookViolationPipe,
    DvirStatusPipe,
    TimeFromNowPipe,
    SecondsToTimePipe,
    LogRecordIconPipe,
    ExpirationDatePipe,
    ViolationTypePipe,
    WarningTypeComparePipe,
    WarningsLabelPipe,
    HasAnyWarningOfTypePipe,
    MalfunctionLabelPipe,
    UserRoleAdaptedPipe,
    LogbookDatePipe,
    ShortTzDisplayPipe,
    TimezonedDatePipe,
    ViolationWarningTooltipPipe,
    CompanyAddressPipe,
    GeofenceTypePipe,
    LatestParamsSyncPipe,
  ],
})
export class CorePipesModule {}
